import { useState, useCallback, useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { isClientSide } from '../../../utilities/user-agent.mjs';

function getWindowSize({
  innerWidth,
  innerHeight,
  outerWidth,
  outerHeight
}) {
  return {
    innerWidth,
    innerHeight,
    outerWidth,
    outerHeight
  };
}
const EMPTY_WINDOW = {
  innerWidth: 0,
  innerHeight: 0,
  outerWidth: 0,
  outerHeight: 0
};

// Adapted from: https://github.com/imbhargav5/rooks
function useWindowSizeOf(element) {
  var _element$ownerDocumen;
  const hasWindow = isClientSide();
  const [windowSize, setWindowSize] = useState(EMPTY_WINDOW);
  const targetWindow = (_element$ownerDocumen = element === null || element === void 0 ? void 0 : element.ownerDocument.defaultView) !== null && _element$ownerDocumen !== void 0 ? _element$ownerDocumen : window;
  const measureWindow = useCallback(() => {
    if (!element && !hasWindow) {
      return EMPTY_WINDOW;
    }
    return getWindowSize(targetWindow);
  }, [element, hasWindow, targetWindow]);
  const measureAndSetWindow = useCallback(() => {
    setWindowSize(measureWindow());
  }, [setWindowSize, measureWindow]);
  const handleResize = useDebouncedCallback(measureAndSetWindow, 10, {
    leading: true
  });
  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize, measureWindow]);
  return windowSize;
}

export { useWindowSizeOf };
